import { connect } from 'react-redux'
import React from 'react'
import { Link, withRouter } from 'react-router-dom'

// Utils
import { logout } from 'app/views/utils/auth'
import {
  getPlan,
} from 'app/state/modules/content'
import {
  getProfile,
  getOrganizations,
} from 'app/state/modules/hacker'


class QuizNavi extends React.PureComponent {
  constructor(props) {
    super(props)

    this.handleClickLogout = this.handleClickLogout.bind(this)
  }

  componentDidMount() {
    this.props.getOrganizations()
    this.props.getProfile()
    this.props.getPlan()
  }

  handleClickLogout() {
    logout()
  }

  render() {
    return (
      <div>
        <div className="uk-background-secondary uk-section uk-padding-remove-bottom uk-light" style={{ height: 80 }}>
          <div className="uk-position-top-left">
            <Link className="uk-navbar-item uk-logo uk-navbar-toggle" to="/">
              <img src="/static/images/logo-white.png" style={{ maxWidth: 129 }} alt="Logo" />
            </Link>
          </div>
          <div className="uk-position-top-right uk-padding-small">
            {(this.props.isAuthenticated) ? (
              <div>
                <Link to="/" style={{ marginRight: 20 }}>
                  Training
                </Link>
                <Link to="#" onClick={this.handleClickLogout}>
                  Sign Out
                </Link>
              </div>
            )
              : (
                <Link to="/login">
                  Login
                </Link>
              )}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.authenticationStatus === 'LOGGED_IN',
})

const mapDispatchToProps = dispatch => ({
  onLogout: () => dispatch(logout()),
  getProfile: () => dispatch(getProfile()),
  getOrganizations: () => dispatch(getOrganizations()),
  getPlan: () => dispatch(getPlan()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizNavi))
